var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-dropdown-section',{attrs:{"title":"Locum Applications","type":"practice-applications-received","items-shown":5,"items":_vm.offers,"event-name":"load-applications-received"},on:{"load-applications-received":_vm.loadMore}})}
var staticRenderFns = []

export { render, staticRenderFns }